import React from 'react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Contact</h1>
          <p className="text-gray-600">هذه الصفحة قيد التطوير</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;